// Overwrites uteContentLoader from app/bower_components/ute-ui/dist/js/ute.ui.debug.js
// Adds uteContentLoader.getContent function.

(function () {

  'use strict';

  // overwrites definition from bower_components/dist/ute-ui.debug.js
  // adds new method: getContent

  /**
   * @author Ronald Nicolls | Chester Rivas
   * @class ute-ui.content
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

    .factory('uteContentLoader', ['$http', 'uteEndpoint', '$compile', 'moment', function ($http, uteEndpoint, $compile, moment) {

      /**
       * @name uteContentLoader
       * @type {object}
       * @memberOf ute-ui.content
       */
      var uteContentLoader = {};

      /**
       * @property uteContentLoader.contentObjects
       * @type {array}
       * @memberOf ute-ui.content.uteContentLoader
       * @description holds each instance of the directive that calls the makeRequest method, using to loop through and match after loading content
       */
      uteContentLoader.contentObjects = [];

      /**
       * @property uteContentLoader.localizedUrl
       * @type {function}
       * @memberOf ute-ui.content.uteContentLoader
       * @description returns a string with the language and province appended
       * @param config - object containing language and province
       * @returns {string}
       */
      uteContentLoader.localizedUrl = function (config) {
        var contentId = config.localContentId || config.contentId;
        var seperator = contentId.indexOf('intergration') === -1 ? '_' : '-';
        return contentId + seperator + config.language + seperator + config.province;
      };

      /**
       * @property uteContentLoader.unescapeHTML
       * @type {function}
       * @memberOf ute-ui.content.uteContentLoader
       * @description converts ascii/html characters to < > characters, also replaces ampersands and a specific pattenr of double quotes
       * @param escapedHTML - string to convert
       * @returns {string}
       */
      uteContentLoader.unescapeHTML = function (escapedHTML) {
        return escapedHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/\\"/g, '"');
      };

      /**
       * @name onCMSLoadSuccess
       * @property uteContentLoader.onCMSLoadSuccess
       * @type {function}
       * @memberOf ute-ui.content.uteContentLoader
       * @description callback for CMS loading success
       * @param {object} currentContentObj - config object
       * @param {object} result - data containing html markup
       */
      uteContentLoader.onCMSLoadSuccess = function (currentContentObj, result) {

        var convertedHTML,
          matchedContent = null;

        // loop through contents object array and find the matching content and it's config object
        _.some(uteContentLoader.contentObjects, function (eachContent) {

          return currentContentObj.rid === eachContent.rid && currentContentObj.element === eachContent.element && (matchedContent = currentContentObj);

        });

        if (matchedContent === null) throw new Error('uteContentLoader error "matchedContent" was not defined');

        // if attribute option compile is set to true then compile the markup
        if (matchedContent.compile) {

          // convert the markup into valid HTML
          //convertedHTML = matchedContent.element.html(result.data).text();

          // populate that markup into the html
          matchedContent.element.html(result.data);

          // compile only the inner markup so there's no recursive loop
          //$compile($element.children().first())($scope.$parent);
          $compile(matchedContent.element.contents())(matchedContent.scope.$parent);

        } else if (matchedContent.fileType === '.json') {

          /*jshint camelcase: false */
          matchedContent.element.children().prepend('<div class="cms-metadata"><span class="content-url">' + uteContentLoader.path.replace('.json', '.html') +
            '</span><span class="edit-date">' + moment().format('MMMM Do YYYY, h:mm:ss a', result.data.editDate) + '</span><span class="version">' +
            result.data.version + '</span><span class="is-published">' + result.data.is_active + '</span><span class="content-edit-url"><a href="' +
            result.data.cmsContentURL + '" target="_blank">Edit</a></span></div>');

        } else {

          convertedHTML = uteContentLoader.unescapeHTML(result.data);
          matchedContent.element.html(convertedHTML);

        }

        matchedContent.element.removeClass('preloader loading');

      };

      /**
       * @property uteContentLoader.onCMSLoadError
       * @type function
       * @description callback for CMS loading error error
       * @memberOf ute-ui.content.uteContentLoader
       * @param {HTMLElement} currentContentObj - config object
       */
      uteContentLoader.onCMSLoadError = function (currentContentObj) {
        var placeholder = '<div class="cms-error"><h6 class="ute-col-alert-danger copy-6 margin-0" title="' + uteContentLoader.localizedUrl(currentContentObj) + currentContentObj.fileType + '"><i class="ute-icon-error ute-col-alert-danger"></i> <ins translate="global.error.inline.cms.loading"></ins></h6></div>';
        currentContentObj.element.removeClass('preloader loading');
        currentContentObj.element.html(placeholder);
      };

      /**
       * @property uteContentLoader.setOptions
       * @type {function}
       * @description sets all the default options before making the $http request
       * @memberOf ute-ui.content.uteContentLoader
       * @param {object} config - config object
       * @property {object} config.scope - scope of the directive
       * @property {string} config.contentId - the id/path to a CMS view from teamsite
       * @property {boolean} config.compile - to compile html string as angular binded markup
       * @property {string} config.language - language en or fr
       * @property {string} config.province - a province
       * @property {string} config.localContentId - the id/path to a local view, used for dev purposes
       */
      uteContentLoader.setOptions = function (config) {

        config.rid = Math.round(Math.random() * 1000);
        config.localContentId = angular.isDefined(config.localContentId) ? uteContentLoader.localizedUrl(config) + '.html' : undefined;

        // push processed object into array
        uteContentLoader.contentObjects.push(config);

        return config;

      };

      /**
       * @property uteContentLoader.makeRequest
       * @type {function}
       * @description make $http request to retrieve content of either html or json file
       * @memberOf ute-ui.content.uteContentLoader
       * @param {object} configObj - object which contains all the data associated with request
       */
      uteContentLoader.makeRequest = function (configObj) {

        // save current config object and push to array
        // returns object with rid defined
        var config = uteContentLoader.setOptions(configObj);

        config.fileType = config.contentId.indexOf('intergration') === -1 ? config.fileType : '.xml';

        //Take parts of configObj.contentId and remove trailing content id after final /
        var parts = config.contentId.split('/'),
          removedContentId = config.contentId.replace(parts[parts.length - 1], '');

        // Use full config.contentId if dateType is html, if dataType is json reform the $scope.contentId to have json subfolder added to it
        config.contentId = config.dataType === 'json' ? removedContentId + '/json/' + parts[parts.length - 1] : config.contentId;

        uteContentLoader.path = uteContentLoader.localizedUrl(config) + config.fileType;

        $http({
          method: config.method,
          dataType: config.dataType,
          url: config.localContentId || uteEndpoint(uteContentLoader.path, 'cms')
        }).then(uteContentLoader.onCMSLoadSuccess.bind(uteContentLoader, config), uteContentLoader.onCMSLoadError.bind(uteContentLoader, config));

      };

      uteContentLoader.getContent = function (configObj) {

        // save current config object and push to array
        // returns object with rid defined
        var config = uteContentLoader.setOptions(configObj);

        config.fileType = config.contentId.indexOf('intergration') === -1 ? config.fileType : '.xml';

        //Take parts of configObj.contentId and remove trailing content id after final /
        var parts = config.contentId.split('/'),
          removedContentId = config.contentId.replace(parts[parts.length - 1], '');

        // Use full config.contentId if dateType is html, if dataType is json reform the $scope.contentId to have json subfolder added to it
        config.contentId = config.dataType === 'json' ? removedContentId + '/json/' + parts[parts.length - 1] : config.contentId;

        // set the path
        var cmsPath = uteContentLoader.localizedUrl(config) + config.fileType;

        return $http({
          method: config.method,
          dataType: config.dataType,
          url: config.localContentId || uteEndpoint(cmsPath, 'cms')
        });
      };

      return uteContentLoader;

    }]);

})();
